import { css as e, styled as t } from "styled-components";
//#region src/components/Carousel/styled/CarouselTrack.styled.ts
var n = t.div`
    display: flex;
    flex-direction: ${({ $orientation: e }) => e === "vertical" ? "column" : "row"};
    gap: ${({ $gap: e }) => e}px;
    height: 100%;
    padding: ${({ $bleed: e }) => e}px;

    /* The items overflow the track, so its end padding never reaches the scroll width
       and the last card ended flush with the viewport, its shadow clipped. A spacer
       exactly the bleed wide (the negative margin cancels the gap) restores it. */
    ${({ $orientation: t, $bleed: n, $gap: r }) => t === "horizontal" && n > 0 && e`
            &::after {
                content: '';
                flex: 0 0 ${n}px;
                margin-inline-start: ${-r}px;
            }
        `}
`, r = t.div`
    margin: ${({ $bleed: e }) => -e}px;
    overflow: ${({ $orientation: e }) => e === "horizontal" ? "auto hidden" : "hidden auto"};
    scroll-behavior: smooth;
    ${({ $snap: t, $orientation: n, $bleed: r }) => t && e`
            scroll-snap-type: ${n === "horizontal" ? "x" : "y"} mandatory;
            scroll-padding-inline: ${r}px;
        `}
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
    flex: 1;
    height: 100%;
    /* Native touch scrolling on iOS/Android */
    -webkit-overflow-scrolling: touch;
`, i = t.div`
    position: absolute;
    top: 0;
    bottom: 0;
    /* Out over the shadow bleed too, or a scrolled card shows again past the fade. */
    ${({ $side: e, $bleed: t }) => `${e}: ${-t}px;`}
    width: ${({ $bleed: e }) => 20 + e}px;
    pointer-events: none;
    z-index: 1;
    background: linear-gradient(
        ${({ $side: e }) => e === "left" ? "to right" : "to left"},
        ${({ theme: e }) => e.colors.background},
        transparent
    );
    opacity: ${({ $visible: e }) => e ? 1 : 0};
    transition: opacity ${({ theme: e }) => e.transitions.fast};
`, a = t.div`
    flex-shrink: 0;
    cursor: pointer;
    ${({ $snap: e }) => e && "scroll-snap-align: start;"}
    border-radius: ${({ theme: e }) => e.radii.lg};
    outline: 2px solid
        ${({ theme: e, $selected: t }) => t ? e.colors.primary : "transparent"};
    outline-offset: 3px;
    transition: outline-color ${({ theme: e }) => e.transitions.fast};

    ${({ $orientation: t, $itemSize: n }) => {
	if (!n) return t === "horizontal" ? e`
                    flex: 0 0 100%;
                    min-width: 100%;
                    height: 100%;
                ` : e`
                flex: 0 0 100%;
                min-height: 100%;
            `;
	let r = typeof n == "number" ? `${n}px` : n;
	return t === "horizontal" ? e`
                width: min(${r}, 100%);
                min-width: min(${r}, 100%);
                max-width: min(${r}, 100%);
            ` : e`
            height: ${r};
            min-height: ${r};
            max-height: ${r};
        `;
}}

    & > * {
        width: 100%;
        height: 100%;
    }
`;
//#endregion
export { i as EdgeFade, a as ItemOuter, n as Track, r as TrackViewport };
